import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { getCurrentSubCategory, getAdditionalDependenciesVisibility } from 'SRC/modules/categories/selectors'
import { getIsBuyingAd } from 'SRC/modules/ads/shared/functions'
import { adPriceTypes } from 'Core/constants'
import { Checkbox } from 'SRC/ui/FormElements'
import { Header } from '../../Header'
import { Price } from '../Price'
import { BuyPrice } from '../BuyPrice'
import { DiscountPrice } from '../DiscountPrice'
import { PriceType } from '../PriceType'
import { PriceTypeForAddons } from '../PriceTypeForAddons'
import { PriceFrom } from '../PriceFrom'
import { PriceTo } from '../PriceTo'
import { Rent } from '../Rent'
import { Description } from '../Description'
import { Swap } from '../Swap'

export class Container extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      showPriceOnRequest: false
    }
  }

  getShowPriceOnRequest = () => {
    const { hasPriceOnRequestAddon, category, isBuyingAd } = this.props

    if (isBuyingAd) return false

    if (category && category.forcePriceOnRequest) {
      return true
    }

    if (category && category.allowPriceOnRequest) {
      return hasPriceOnRequestAddon
    }

    return false
  }

  async componentDidMount () {
    const { priceOnRequest, formName } = this.props
    const showPriceOnRequest = this.getShowPriceOnRequest()

    if (!showPriceOnRequest && priceOnRequest) {
      await this.props.change(formName, 'priceOnRequest', false)
    }

    this.setState({ showPriceOnRequest })
  }

  getPriceTypeForAddonsOptions = () => {
    const { hasPriceFromToAddon } = this.props
    const options = [
      {
        id: adPriceTypes.retail.id,
        label: adPriceTypes.retail.title,
        value: adPriceTypes.retail.id
      }
    ]

    if (hasPriceFromToAddon) {
      options.push({
        id: adPriceTypes.fromTo.id,
        label: adPriceTypes.fromTo.title,
        value: adPriceTypes.fromTo.id
      })
    }
    return options
  }

  onPriceTypeForAddonsChange = async e => {
    const value = Number(e.target.value)
    if (value) {
      switch (value) {
        case adPriceTypes.retail.id:
          await this.props.change(this.props.formName, 'priceFrom', null)
          await this.props.change(this.props.formName, 'priceTo', null)
          break
        case adPriceTypes.fromTo.id:
          await this.props.change(this.props.formName, 'price', null)
          await this.props.change(this.props.formName, 'priceUnmasked', null)
          await this.props.change(this.props.formName, 'discountedPrice', null)
          await this.props.change(this.props.formName, 'discountedPriceUnmasked', null)
          break
        default:
          await this.props.change(this.props.formName, 'price', null)
          await this.props.change(this.props.formName, 'priceUnmasked', null)
          await this.props.change(this.props.formName, 'discountedPrice', null)
          await this.props.change(this.props.formName, 'discountedPriceUnmasked', null)
          await this.props.change(this.props.formName, 'priceFrom', null)
          await this.props.change(this.props.formName, 'priceTo', null)
          break
      }
    }
  }

  onPriceOnRequestChange = async e => {
    const checked = e.target.checked
    if (checked) {
      await this.props.change(this.props.formName, 'price', null)
      await this.props.change(this.props.formName, 'priceUnmasked', null)
      await this.props.change(this.props.formName, 'discountedPrice', null)
      await this.props.change(this.props.formName, 'discountedPriceUnmasked', null)
      await this.props.change(this.props.formName, 'priceFrom', null)
      await this.props.change(this.props.formName, 'priceTo', null)
    }
  }

  renderPriceOnRequest = () => {
    const { showPriceOnRequest } = this.state

    if (!showPriceOnRequest) return null

    return (
      <div style={{ width: '100%', float: 'left' }} key='price-fields'>
        <Checkbox
          id='priceOnRequest'
          label='Cijena na upit'
          name='priceOnRequest'
          onInput={this.onPriceOnRequestChange}
        />
      </div>
    )
  }

  renderRegularPrice = () => {
    const {
      formName,
      isBuyingAd,
      priceOnRequest,
      showRent,
      priceTypeForAddons,
      isBasicForm
    } = this.props

    if (priceOnRequest) return null
    if (showRent) return null
    if (priceTypeForAddons && Number(priceTypeForAddons) === adPriceTypes.fromTo.id) return null

    if (isBuyingAd) {
      return <BuyPrice formName={formName} />
    }

    return (
      <React.Fragment>
        <Price formName={formName} />
        {!isBasicForm ? <DiscountPrice formName={formName} /> : null}
      </React.Fragment>
    )
  }

  renderRentPrice = () => {
    const {
      formName,
      isBuyingAd,
      priceOnRequest,
      showRent,
      adPriceDaily,
      adPriceMonthly
    } = this.props

    if (isBuyingAd) return null
    if (priceOnRequest) return null
    if (!showRent) return null

    return (
      <Rent
        formName={formName}
        adPriceDaily={adPriceDaily}
        adPriceMonthly={adPriceMonthly}
      />
    )
  }

  renderRangePrice = () => {
    const {
      formName,
      isBuyingAd,
      priceOnRequest,
      showRent,
      showFromToPrice
    } = this.props

    if (isBuyingAd) return null
    if (priceOnRequest) return null
    if (!showFromToPrice) return null
    if (showRent) return null

    return (
      <div key='price-from-to' style={{ width: '100%', float: 'left' }}>
        <PriceFrom formName={formName} />
        <PriceTo formName={formName} />
      </div>
    )
  }

  renderPriceType = () => {
    const { isBuyingAd, priceOnRequest } = this.props

    if (isBuyingAd) return null
    if (priceOnRequest) return null

    return <PriceType />
  }

  renderPriceTypeForAddons = () => {
    const { isBuyingAd, priceOnRequest, hasPriceFromToAddon, showRent } = this.props

    if (isBuyingAd) return null
    if (priceOnRequest) return null
    if (!hasPriceFromToAddon) return null
    if (showRent) return null

    return (
      <PriceTypeForAddons
        options={this.getPriceTypeForAddonsOptions()}
        onChange={this.onPriceTypeForAddonsChange}
      />
    )
  }

  renderDelivery = () => {
    const { isBuyingAd, priceOnRequest, hasDeliveryAddon, showRent } = this.props

    if (isBuyingAd) return null
    if (priceOnRequest) return null
    if (!hasDeliveryAddon) return null
    if (showRent) return null

    return (
      <Checkbox
        id='deliver-checkbox'
        name='itemDelivery'
        label='Omogući dostavu'
      />
    )
  }

  render () {
    const { formName, swap, adsSwapps, isBuyingAd } = this.props

    return (
      <React.Fragment>
        <Header title='Cijena, opis i zamjena' key='header' />

        <div className='ads-add__price-description'>
          <div className='left-inputs' key='left-fields'>
            {this.renderPriceOnRequest()}
            {this.renderRegularPrice()}
            {this.renderRentPrice()}
            {this.renderPriceType()}
            {this.renderPriceTypeForAddons()}
            {this.renderRangePrice()}
            {this.renderDelivery()}
          </div>
          <Description key='description-field' />
        </div>

        {!isBuyingAd ? <Swap key='swap-field' formName={formName} swapp={swap} adsSwapps={adsSwapps} /> : null}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(ownProps.formName)

  const priceTypeForAddons = selector(state, 'priceTypeForAddons')

  const priceOnRequest = selector(state, 'priceOnRequest')

  const showFromToPrice = priceTypeForAddons && !priceOnRequest &&
    Number(priceTypeForAddons) === adPriceTypes.fromTo.id && ownProps.hasPriceFromToAddon

  const additionalDependenciesVisibility = getAdditionalDependenciesVisibility(state)

  const showRent = !priceOnRequest && additionalDependenciesVisibility && additionalDependenciesVisibility.price_period

  const category = getCurrentSubCategory(state)

  return {
    category,
    showFromToPrice,
    showRent,
    priceTypeForAddons,
    priceOnRequest,
    isBuyingAd: getIsBuyingAd(selector(state, 'isBuying'))
  }
}

Container.displayName = 'Props'

Container.propTypes = {
  category: PropTypes.shape({
    allowPriceOnRequest: PropTypes.bool,
    forcePriceOnRequest: PropTypes.bool
  }).isRequired,
  adsSwapps: PropTypes.any,
  formName: PropTypes.any,
  swap: PropTypes.any,
  adPriceDaily: PropTypes.number,
  adPriceMonthly: PropTypes.number,
  priceTypeForAddons: PropTypes.number.isRequired,
  priceOnRequest: PropTypes.bool.isRequired,
  isBasicForm: PropTypes.bool,
  hasPriceFromToAddon: PropTypes.bool.isRequired,
  hasPriceOnRequestAddon: PropTypes.bool.isRequired,
  hasDeliveryAddon: PropTypes.bool.isRequired,
  showFromToPrice: PropTypes.bool,
  showRent: PropTypes.bool,
  isBuyingAd: PropTypes.bool,
  change: PropTypes.func.isRequired
}

export default connect(mapStateToProps, { change })(Container)
